import React from "react";
import { graniteData } from "../../../data";

function Granite() {
  const { brand, slogan, description, productLineup, attributes, partnership } =
    graniteData;

  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{brand}</h1>
        {slogan && (
          <p className="text-sm italic text-gray-500 mb-1">“{slogan}”</p>
        )}
        <p className="text-gray-700 leading-relaxed text-base">{description}</p>
      </div>

      {/* Product Lineup */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Product Lineup
        </h2>
        <div className="space-y-4">
          {productLineup.categories.map((category, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold text-gray-800">
                {category.name}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                {category.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Attributes */}
      <div className="max-sm:px-4">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Attributes</h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          {Object.entries(attributes).map(([key, value]) => (
            <li key={key}>
              <span className="font-medium text-gray-900">{key}:</span>{" "}
              {value.toString()}
            </li>
          ))}
        </ul>
      </div>

      {/* Partnership */}
      <div className="max-sm:px-4">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">
          Partnership with {partnership.partner}
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed">
          {partnership.description}
        </p>
      </div>
    </div>
  );
}

export default Granite;
